import React from "react";
import style from "../../../assets/css/proposal.module.scss";
import {Button} from "@mui/material";
import {IoIosArrowRoundBack} from "react-icons/io";
import {useDispatch, useSelector} from "react-redux";
import {setDataStore} from "../../../store/dataSlice";
import {selectDataStoreState} from "../../../store/dataSlice";
import {HiOutlinePaperClip} from "react-icons/hi2";
import {isMobileOnly} from "react-device-detect";
import {IoSaveOutline} from "react-icons/io5";
import {FiEdit} from "react-icons/fi";
import {LuUpload} from "react-icons/lu";

const NewProposalFooter = ({
  leftGridWidth,
  submitForm,
  handleSave,
  nextPage = false,
  handleSaveDraft,
  disableDraft = false,
}) => {
  const dispatch = useDispatch();
  const {proposalStep} = useSelector(selectDataStoreState);

  if (leftGridWidth === 0) {
    return null;
  }

  const handleContinue = () => {
    if (proposalStep <= 12) {
      // console.log("A 0000000",nextPage,submitForm,proposalStep)
      if (nextPage) {
        dispatch(
          setDataStore({
            proposalStep: proposalStep + 1,
          })
        );
        // console.log("A")
      } else if (submitForm !== undefined) {
        //console.log("A 2");
        submitForm();
      }
      // return;
    }
  };

  const handleBack = () => {
    if (proposalStep > 1) {
      dispatch(
        setDataStore({
          proposalStep: proposalStep - 1,
        })
      );
    }
  };

  // const handleReset = () => {
  //   dispatch(
  //     setDataStore({
  //       proposalStep: 1,
  //     })
  //   );
  // };

  // const handleStep = (currentStep) => {
  //   dispatch(
  //     setDataStore({
  //       proposalStep: currentStep,
  //     })
  //   );
  // };
  // const handleSave = () => { };

  return (
    <>
      <div
        className={style.proposalFooterMain}
        style={{width: `calc(100% - ${leftGridWidth + 20}px)`}}
      >
        <div className={style.proposalFooterleft}>
          <Button
            variant="contained"
            className={style.ftBackBtn}
            onClick={handleBack}
            disabled={proposalStep === 1}
          >
            <IoIosArrowRoundBack /> {isMobileOnly ? null : "Back"}
          </Button>
        </div>
        <div className={style.proposalFooterRight}>
          {/* <Button
            variant="contained"
            className={style.ftContinueBtn + " " + style.proposalFooterDraftBtn}
            onClick={handleSaveDraft}
            disabled={disableDraft}
          >
            {isMobileOnly ? <FiEdit /> : "Save Draft"}
          </Button> */}
          <Button
            variant="contained"
            className={style.ftContinueBtn}
            onClick={handleContinue}
            type="submit"
          >
            {proposalStep < 12 ? (
              <>
                {isMobileOnly ? null : "Save & Continue"}{" "}
                <IoIosArrowRoundBack />
              </>
            ) : (
              <>
                {isMobileOnly ? (
                  <>
                    <LuUpload
                      style={{fontSize: "23px", transform: "inherit"}}
                    />
                  </>
                ) : (
                  "Save / Submit"
                )}
              </>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default NewProposalFooter;
